import { Form } from "antd";
import styled from "styled-components";

export const PageHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 5px;
  margin-bottom: 10px;
`;

export const StyledForm = styled(Form)`
  margin: 0 auto;
  padding: 50px;
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  margin-bottom : 10px;
`;

export const StyledContentItem = styled.div`
  margin: 10px;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 5px;
`;

export const CreateContentBox = styled.div`
    padding: 25px;
    border: 1px solid #d9d9d9;
    border-radius: 5px;
    margin-bottom: 20px;
`

export const PreviewContainer = styled.div`
  padding: 20px;
`;